module.exports = __webpack_public_path__ + "static/media/globe.aab1527b.png";